import { render } from "./MapCard.vue?vue&type=template&id=9005148c&scoped=true"
import script from "./MapCard.vue?vue&type=script&lang=js"
export * from "./MapCard.vue?vue&type=script&lang=js"

import "./MapCard.vue?vue&type=style&index=0&id=9005148c&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9005148c"]])

export default __exports__